module.exports = __webpack_public_path__ + "img/project-15.1025716f.png";